<template>
  <transition
    name="cpost-result"
  >
    <div
      v-if="address.verified"
      class="app-cpost-result"
    >
      <small class="app-cpost-result__selected">
        The Address you have selected is:
      </small>
      <h4
        class="app-cpost-result__address"
        :class="textColorClass()"
      >
        <span v-if="address.line1">
          {{ address.line1 }},
        </span>
        <span v-if="address.line2">
          {{ address.line2 }},
        </span>
        {{ address.city }}
        {{ address.province }},
        {{ address.postalCode }}
      </h4>
    </div>
  </transition>
</template>

<script>
import theme from '@/mixins/theme'

export default {
  // Name
  name: 'AppCanadaPostResult',

  mixins: [theme],

  // Props
  props: {
    address: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.app-cpost-result {
  @apply p-20 text-center relative z-0 mt-25;
  @apply bg-white border-2 border-purple-100;

  @screen sm {
    @apply mt-0 top-[-5px];
  }

  &::after {
    @apply absolute text-xxs top-[-13px] left-[10px] w-20 h-20;
    @apply bg-white border-l-2 border-t-2 border-purple-100;

    content: '';
    transform: rotate(45deg) skew(15deg, 15deg);
  }

  &__selected {
    @apply font-semibold text-base mb-5;
  }

  &__address {
    @apply font-body text-base font-light;
  }
}

// Canada Post Results Tansition
.cpost-result-enter-active,
.cpost-result-leave-active {
  transition: all 0.5s;
  transform: translateY(0);
  z-index: 1;
}

.cpost-result-enter,
.cpost-result-leave-to {
  opacity: 0;
  transform: translateY(-50px);
  z-index: 1;
}
</style>
